import {
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Optional,
    Output,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { EntityBrowserComponent } from '../../entity-browser/entity-browser.component';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { get } from 'lodash-es';
import { Subject } from 'rxjs';

@Component({
    template: '',
    standalone: false,
})
export class TableColumnComponent implements OnInit, OnDestroy {
    @ViewChild(MatColumnDef) columnDef: MatColumnDef;

    @Output() public FilterChange: EventEmitter<string> = new EventEmitter<string>();
    @Input() public isOrgChanged: boolean;
    @Input() public columnKeyName: string;
    @Input() public title: string;
    @Input() public entityBrowser: EntityBrowserComponent<any>;
    @Optional() @Input() public entityProperty: string;
    @Optional() @Input() public cellTemplate: TemplateRef<any>;
    @Optional() @Input() public sortable = true;
    @Optional() @Input() public disabled = false;
    @Optional() @Input() public sortingKeyName: string;

    protected filterValue: string;
    protected clearAllFilters = new Subject<boolean>();

    constructor(public table: MatTable<any>, private cdRef: ChangeDetectorRef) {}

    @Input()
    public get Filter(): any {
        return this.filterValue;
    }

    public set Filter(value: any) {
        this.filterValue = value === undefined || value === null ? '' : value;
        this.FilterChange.emit(this.filterValue);
    }

    ngOnInit() {
        if (this.table) {
            this.cdRef.detectChanges();
            this.table.addColumnDef(this.columnDef);
        }

        this.sortingKeyName = this.sortingKeyName ?? this.columnKeyName;
        this.entityProperty = this.entityProperty ?? this.columnKeyName;
        if (this.columnKeyName === 'status') {
            this.entityBrowser.getClearAllFiltersObs().subscribe((value) => {
                this.Filter = '';
            });
        }
    }

    public getEntityProperty(entity: any): string {
        return get(entity, this.entityProperty);
    }

    ngOnDestroy(): void {
        if (this.table) {
            this.table.removeColumnDef(this.columnDef);
        }
    }
}
